<template>
  <div class="vi-home">
    <vi-home-hero-search v-if="$route.path == '/' && $route.fullPath != '/#services'" />
    <vi-home-others v-if="$route.path == '/'" />
        <router-view></router-view>

      <!-- <NavBar /> -->
  </div>
</template>

<script>
import ViHomeHeroSearch from "../components/Home/ViHomeHeroSearch";
import ViHomeOthers from "../components/Home/ViHomeOthers";
import ViSpinner from "../components/Common/ViSpinner.vue";
import secureUI from "../utils/secureUI";
import NavBar from "@/views/ViNavBar.vue";

// import ViService from "@/services/ViService";

export default {
  name: "vi-home",
   data() {
    return {
      viLoader: false
    };
  },
  components: {
    NavBar
  },
  created() {
	  this.initMethod();
  },
  
  methods: {
    
    initMethod() {
      this.viLoader = true
       setTimeout(() => {
        this.viLoader = false
       }, 500);

      let userData = secureUI.sessionGet("user");

      if (userData) {
       
           if(userData.userDetails.profile.name == 'School Admin'){
            if(userData.userDetails.account){

            if(userData.userDetails.account.version != 'freeVersion'){
              if(userData.subscription.status == 'unpaid' || userData.subscription.status == 'cancelled'){
                const appUrl = 'https://admin--stage.vidhyaan.com'
                window.location.href = appUrl + '/admission/admissionSettings' + `?token=${encodeURIComponent( localStorage.getItem("user") ).trim()}`;
                // this.$router.push("/admission/admissionSettings");
              }             
            }
          }else{
            localStorage.removeItem("user");
              this.$router.push("/login");
          }
            
       }
      }
    }
  },
 
  components: { ViHomeHeroSearch, ViHomeOthers, ViSpinner},
};
</script>

<style lang="scss" scoped></style>
